export default "__VITE_ASSET__cn7IAAGY294pWGc7MpElVg__ 64w, __VITE_ASSET__DUq8YoikZLXEejpNZ1KQvg__ 128w";